module.exports = __webpack_public_path__ + "img/cloud-01.ce0d83b6.png";